import { render, staticRenderFns } from "./oreder-refound-explain.vue?vue&type=template&id=42c64a9a&scoped=true&"
import script from "./oreder-refound-explain.vue?vue&type=script&lang=js&"
export * from "./oreder-refound-explain.vue?vue&type=script&lang=js&"
import style0 from "./oreder-refound-explain.vue?vue&type=style&index=0&id=42c64a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c64a9a",
  null
  
)

export default component.exports